import { AttributeNavigationIconEnum } from "@centricsoftware/design-system";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import { C8AttributeType, C8NodeType, VALUE_TYPE, getPrimitiveValueType } from "c8-platform";
import ImageIcon from "csi/middleware/icons/ImageIcon";
import PhoneIcon from "csi/middleware/icons/PhoneIcon";
import { TYPE_IMAGE, TYPE_USER } from "csi/reflection/reflectionConstants";
import types from "csi/types";
import { isCurrencyFormat, isPercentFormat } from "csi/utility/numberUtility";
import { FC, SVGProps } from "react";

const {
	FORMAT_BARCODE,
	FORMAT_COMMENT,
	FORMAT_COMMENT_LATEST,
	FORMAT_EMAIL,
	FORMAT_IMAGE,
	FORMAT_LOCALIZED,
	FORMAT_LOCALIZED_TEXTAREA,
	FORMAT_LOCALIZED_RICH,
	FORMAT_PHONE,
	FORMAT_RICH,
	FORMAT_SELECTION,
	FORMAT_TAG,
	FORMAT_TEXTAREA,
	FORMAT_TYPE,
	FORMAT_URL,
} = types;

const {
	BOOLEAN,
	DOUBLE,
	ENUM,
	INTEGER,
	INT64,
	REF,
	STRING,
	TIME,
	URL,
} = VALUE_TYPE;

const REF_TARGET_ICONS: Record<C8NodeType, AttributeNavigationIconEnum | FC<SVGProps<SVGSVGElement>>> = {
	// TODO: add these to DS
	[TYPE_IMAGE]: ImageIcon,
	[TYPE_USER]: PersonOutlineOutlinedIcon,
};

/** return icon string based on given attribute type and format and target type in case of ref attribute */
export function getAttributeIcon(type?: C8AttributeType, format?: string, relationshipTargetType?: C8NodeType): AttributeNavigationIconEnum | FC<SVGProps<SVGSVGElement>> {
	if (type) {
		const baseType = getPrimitiveValueType(type);

		switch (baseType) {
			case BOOLEAN: {
				return AttributeNavigationIconEnum.Boolean;
			}
			case DOUBLE:
			case INTEGER:
			case INT64: {
				return isPercentFormat(format) ? AttributeNavigationIconEnum.Percent : (isCurrencyFormat(format) ? AttributeNavigationIconEnum.Currency : AttributeNavigationIconEnum.Number);
			}
			case ENUM: {
				return AttributeNavigationIconEnum.Dropdown;
			}
			case REF: {
				return REF_TARGET_ICONS[relationshipTargetType] ?? AttributeNavigationIconEnum.Referral;
			}
			case STRING: {
				switch (format) {
					case FORMAT_BARCODE:
						return AttributeNavigationIconEnum.Barcode;
					case FORMAT_COMMENT:
					case FORMAT_COMMENT_LATEST:
						return AttributeNavigationIconEnum.Comment;
					case FORMAT_EMAIL:
						return AttributeNavigationIconEnum.Email;
					case FORMAT_LOCALIZED:
					case FORMAT_LOCALIZED_TEXTAREA:
					case FORMAT_TEXTAREA:
					case FORMAT_TYPE:
						return AttributeNavigationIconEnum.Text;
					case FORMAT_LOCALIZED_RICH:
					case FORMAT_RICH:
						return AttributeNavigationIconEnum.RichText;
					case FORMAT_PHONE:
						// TODO: add phone icon to DS
						return PhoneIcon;
					case FORMAT_SELECTION:
					case FORMAT_TAG:
						return AttributeNavigationIconEnum.Dropdown;
					case FORMAT_URL:
						return AttributeNavigationIconEnum.Link;
					default:
						return AttributeNavigationIconEnum.Text;
				}
			}
			case TIME: {
				return AttributeNavigationIconEnum.Calendar;
			}
			case URL: {
				// TODO add image icon to DS
				return (format === FORMAT_IMAGE) ? ImageIcon : AttributeNavigationIconEnum.File;
			}
		}
	}

	return AttributeNavigationIconEnum.Text;
}